import { Col, Divider, Modal, Row, Skeleton, Space } from "antd";
import React, { useEffect } from "react";
import Text from "../Text/Text";
import { numberFormatter } from "../../utility/Formatter";
import { getDetail } from "../../datasource/OrderCreditDatasource";
import { color } from "../../resource";

interface Props {
  open: boolean;
  onClose: () => void;
  cusComId?: string;
}

function NewModalInfoCredit({ open, onClose, cusComId }: Props) {
  const [data, setData] = React.useState<any>(null);
  const [mapData, setMapData] = React.useState<any>(null);

  const fetchData = async () => {
    await getDetail(cusComId!).then((res) => {
      const mapData = [
        {
          key: 1,
          label: "วงเงินหลัก (Credit Limit)",
          value: numberFormatter(res.creditLimit || 0),
          desc: (
            <>
              ใช้แล้ว <b>{numberFormatter(res.creditLimitUsedApp || 0)}</b> บาท | คงเหลือ{" "}
              <b style={{ color: res.primaryBalanceApp < 0 ? "red" : "black" }}>
                {numberFormatter(res.primaryBalanceApp || 0)}
              </b>{" "}
              บาท
            </>
          ),
          percent: numberFormatter(res.creditLimitUsedPercentApp || 0),
          textColor: "",
        },
        {
          key: 2,
          label: "วงเงินชั่วคราว (Temporary Credit Limit)",
          value: numberFormatter(res.overCredit || 0),
          desc: (
            <>
              ใช้แล้ว <b>{numberFormatter(res.overCreditUsedApp || 0)}</b> บาท | คงเหลือ{" "}
              <b style={{ color: res.overCreditBalanceApp < 0 ? "red" : "black" }}>
                {numberFormatter(res.overCreditBalanceApp || 0)}
              </b>{" "}
              บาท
            </>
          ),
          percent: numberFormatter(res.overCreditPercentApp || 0),
          textColor: "",
        },
        {
          key: 3,
          label: "วงเงินรวมทั้งหมด (Total Credit Limit)",
          value: numberFormatter(res.creditLimitTotal || 0),
          desc: (
            <>
              ใช้แล้ว <b>{numberFormatter(res.creditLimitTotalUsedDetail || 0)}</b> บาท | คงเหลือ{" "}
              <b
                style={{
                  color:
                    res.creditLimitTotal - res.creditLimitTotalUsedDetail < 0 ? "red" : "black",
                }}
              >
                {numberFormatter(res.creditLimitTotal - res.creditLimitTotalUsedDetail || 0)}
              </b>{" "}
              บาท
            </>
          ),
          percent: numberFormatter(res.creditLimitTotalBalancePercent || 0),
          textColor: "",
        },
        {
          key: 4,
          label: "วงเงินคงเหลือ (Credit Limit Balance)",
          value: numberFormatter(res.creditLimitBalance || 0),
          desc: `* ยอดชำระเงินเกินจะถูกเพิ่มในวงเงินคงเหลือ *`,
          percent: numberFormatter(res.percentCreditBalance || 0),
          textColor: "error",
        },
        {
          key: 5,
          label: "ลูกหนี้การค้า (A/R Balance)",
          value: numberFormatter(res.arBalance || 0),
          desc: ``,
          percent: numberFormatter(res.arBalancePercent || 0),
          textColor: "error",
        },
        {
          key: 6,
          label: "คำสั่งซื้อที่รอดำเนินการ (Order pending)",
          value: numberFormatter(res.pending || 0),
          desc: ``,
          percent: numberFormatter(res.pendingPercent || 0),
          textColor: "error",
        },
        {
          key: 7,
          label: "ยอดหนี้ค้างชำระ (Outstanding)",
          value: numberFormatter(res.outstanding || 0),
          desc: ``,
          percent: numberFormatter(res.outstandingPercent || 0),
          textColor: "error",
        },
        {
          key: 8,
          label: "เช็คลงวันที่ล่วงหน้า (PDC)",
          value: numberFormatter(res.pdcCollect || 0),
          desc: ``,
          percent: numberFormatter(res.pdcCollectPercent || 0),
          textColor: "success",
        },
        {
          key: 9,
          label: "วงเงินเกินสะสม (Over Credit)",
          value: numberFormatter(res.sumOverCredit || 0),
          desc: ``,
          percent: numberFormatter(res.sumOverCreditPercent || 0),
          textColor: "error",
        },
      ];

      setData(res);
      setMapData(mapData);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Modal
      width={600}
      maskClosable={false}
      open={open}
      closable
      onCancel={onClose}
      title={
        <>
          <Text fontWeight={600} fontSize={20} color='Text2'>
            ข้อมูลวงเงินร้านค้า
          </Text>
          <br />
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            {data?.customerName}&nbsp;|&nbsp;
          </Text>
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            เขต {data?.zone} {data?.province && `(${data?.province})`}&nbsp;|&nbsp;
          </Text>
          <Text fontWeight={400} fontSize={14} color='Text3' fontFamily='Sarabun'>
            รูปแบบ {data?.termPaymentType === "CREDIT" ? "เครดิต" : "เงินสด"}
          </Text>
        </>
      }
      centered
      footer={null}
    >
      <Divider size='small' />
      <Skeleton loading={!mapData} active paragraph={{ rows: 9 }} title={false}>
        {mapData?.map((item: any) => (
          <>
            <Row key={item.key} justify='space-between' align='middle'>
              <Col span={18}>
                <Text fontWeight={600}>{item.label}</Text>
                <br />
                <Text level={6}>{item.desc}</Text>
              </Col>
              <Col span={6} style={{ textAlign: "right" }}>
                <Text
                  color={
                    item.label.includes("วงเงินคงเหลือ")
                      ? item.textColor && parseFloat(item.value) < 0
                        ? "error"
                        : "BK"
                      : item.textColor && parseFloat(item.value) !== 0
                        ? item.textColor
                        : "BK"
                  }
                  fontWeight={600}
                >
                  {item.value}
                </Text>{" "}
                <br />
                <Text
                  level={6}
                  color={
                    item.label.includes("วงเงินคงเหลือ")
                      ? item.textColor && parseFloat(item.value) < 0
                        ? "error"
                        : "BK"
                      : item.textColor && parseFloat(item.percent) !== 0
                        ? item.textColor
                        : "Text3"
                  }
                >
                  ({item.percent}%)
                </Text>
              </Col>
            </Row>
            <Divider size='small' />
          </>
        ))}
      </Skeleton>
    </Modal>
  );
}

export default NewModalInfoCredit;
